import { JsonConverter, JsonCustomConvert } from 'json2typescript';

import { ClientStatus } from '../../../../../core';

@JsonConverter
export class ClientStatusAdapter implements JsonCustomConvert<ClientStatus | undefined> {
    serialize(status: ClientStatus): any | undefined {
        return status ? String(status) : undefined;
    }

    deserialize(status: any): ClientStatus | undefined {
        switch (status) {
            case 'POTENCIAL':
                return ClientStatus.PROSPECT;
            case 'PREVALIDATED':
                return ClientStatus.PRE_VALIDATED;
            case 'VALIDATED':
                return ClientStatus.VALIDATED;
            case 'CLIENT':
                return ClientStatus.CLIENT;
            case 'REJECTED':
                return ClientStatus.REJECTED;
            case 'ERROR':
                return ClientStatus.ERROR;
            default:
                return ClientStatus.OTHER;
        }
    }
}
